import React from "react";

export default function HamburgerIcon() {
  return (
    <span
      className="flex h-9 w-9 flex-col items-end justify-center gap-[5px]"
      aria-hidden="true"
    >
      <span className="block h-[2px] w-7 rounded-full bg-white shadow-[0_0_8px_rgba(255,255,255,0.24)] transition duration-200 group-hover:w-8 group-hover:bg-white" />
      <span className="block h-[2px] w-5 rounded-full bg-white shadow-[0_0_8px_rgba(255,255,255,0.24)] transition duration-200 group-hover:w-6 group-hover:bg-white" />
      <span className="block h-[2px] w-7 rounded-full bg-white shadow-[0_0_8px_rgba(255,255,255,0.24)] transition duration-200 group-hover:w-8 group-hover:bg-white" />
    </span>
  );
}
